import {
    EuiButtonIcon,
    EuiContextMenuItem,
    EuiContextMenuPanel,
    EuiPopover,
    useGeneratedHtmlId,
} from "@elastic/eui";
import React, { useState } from "react";
import trackAnalytics from "../../../trackAnalytics";

function Edit({ onEdit, entityName }) {
    const [isPopoverOpen, setPopover] = useState(false);

    const onButtonClick = () => {
        trackAnalytics(`${entityName}_profile_edit`);
        onEdit(true);
        setPopover(!isPopoverOpen);
    };

    const toggelPopover = () => {
        setPopover(!isPopoverOpen);
    };

    const items = [
        <EuiContextMenuItem
            key="edit"
            icon="pencil"
            onClick={onButtonClick}
        >
            Edit
        </EuiContextMenuItem>,
    ];
    return (
        <div>
            <EuiPopover
                id="12ff"
                button={
                    <EuiButtonIcon
                        display="base"
                        size="s"
                        iconType="boxesVertical"
                        aria-label="More"
                        onClick={toggelPopover}
                    />
                }
                isOpen={isPopoverOpen}
                closePopover={toggelPopover}
                panelPaddingSize="none"
                anchorPosition="downLeft"
            >
                <EuiContextMenuPanel
                    size="s"
                    items={items}
                />
            </EuiPopover>
        </div>
    );
}

export default Edit;
